var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-develop"},[_c('Common-Shell',{attrs:{"type":"deviceDevelop","search-option":_vm.searchOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }